import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { Group } from '../domain/group';
import type { Invitation } from '../domain/invitation';

const initialState: { list: Group[], invite?: Invitation} = { list: [] };


const invitationSlice = createSlice({
    initialState,
    name: 'invitation',
    reducers: {
        clearGroups: () => initialState,
        setGroups: (state, action: PayloadAction<Group[]>) => {
            state.list = action.payload;
        }
    }
    
});

export const { setGroups } = invitationSlice.actions;
export default invitationSlice.reducer;
